import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "device-rerun",
  "use": "device-rerun-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"device-rerun\"><path d=\"M8 3.75a4.25 4.25 0 1 0 2.975 7.285.75.75 0 0 1 1.05 1.071A5.75 5.75 0 1 1 13.75 8a.75.75 0 0 1-.987.712l-3-1a.75.75 0 1 1 .474-1.424l1.873.625A4.252 4.252 0 0 0 8 3.75z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol